export class ClientBoard {
  // key: SELL, RENT, OTM, VAC
  // value's size is 11
  statusScores: {[key: string]: number[]; };

  // key: unit, villa, T.house, P.house, Land, house, house + GF
  // value's size is 11
  typeScores: {[key: string]: number[]; };
}
